import grayLoaderImg from "../../images/loading_gray.gif";
import loadingImg from "../../images/loading_image.svg";
import noDataImg from "../../images/no_data_image.svg";
import { REQUEST_STATES } from "../../utils/constants";
import { CenteredDiv, Container } from "./DamLoaderStyles";
import useLoadingMessage from "./useLoadingMessage";

function DamLoader(props) {
  const { damLoaderState } = props;
  const loadingMessage = useLoadingMessage();

  return (
    <Container>
      <CenteredDiv>
        {damLoaderState === REQUEST_STATES.PRE_REQUEST ? (
          <>
            <img
              src={noDataImg}
              alt="Sin datos disponibles."
              className="no-data"
            />
            <h1>Sin registros aún</h1>
            <h2>Consulta una DAM para ver los volantes</h2>
          </>
        ) : null}
        {damLoaderState === REQUEST_STATES.REQUEST_IN_PROGRESS ? (
          <>
            <img
              src={loadingImg}
              alt="Solicitando datos."
              className="requesting-data"
            />
            <h1>
              <img src={grayLoaderImg} alt="Cargando" /> Cargando...
            </h1>
            <h2>{`Consultando a ${loadingMessage}`}...</h2>
          </>
        ) : null}
      </CenteredDiv>
    </Container>
  );
}

export default DamLoader;
